import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { RequestProposalState } from '../types';

export const getInitialRequestProposalState = (): RequestProposalState => ({
    selectedDealTypes: [],
    selectedIncentives: [],
    notes: '',
    isRequestChangeModalOpen: false,
    dealPdfUrl: '',
    dealPdfVersion: undefined,
    showConfetti: false,
    dealPdfFetchStatus: ApiRequestStatus.Idle,
    isDealPdfLoading: false,
    requestStatus: ApiRequestStatus.Idle
});
